// 秒转天
export default function secondToDay(second: number|null|undefined):string {
  if(!second) return '0天';
  
  if(parseInt(String(second/(24*60*60)),0) > 999) return '999+天'

  return `${parseInt(String(second/(24*60*60)),0)}天`
}

interface secondToObjType {
  days?: number;
  hours?: number;
  minutes?: number;
}
export function secondToObj(seconds:number|null|undefined):secondToObjType {
  if(!seconds) return {
    days: 0,
    hours:0,
    minutes:0
  }

  let days = Math.floor(seconds / 86400);
  let hours = Math.floor((seconds - days * 86400) / 3600);
  let minutes = Math.floor((seconds - days * 86400 - hours * 3600) / 60);
  return {
    days,
    hours,
    minutes
  }
}
